export type Priority = 0 | 1 | 2 | 3
export type PriorityColor = 'secondary' | 'info' | 'warning' | 'primary'

interface PriorityConfig {
  display_name: string
  color: PriorityColor
  order: number
}

export const PRIORITY_CONFIG: Record<Priority, PriorityConfig> = {
  3: { display_name: 'Urgent', color: 'primary', order: 1 },
  2: { display_name: 'High', color: 'warning', order: 2 },
  1: { display_name: 'Medium', color: 'info', order: 3 },
  0: { display_name: 'Low', color: 'secondary', order: 4 },
}

const DEFAULT_PRIORITY: Priority = 0

const toPriority = (value: unknown): Priority => {
  const num = Number(value)
  return num in PRIORITY_CONFIG ? (num as Priority) : DEFAULT_PRIORITY
}

export function usePriority() {
  const getPriorityColor = (priority: any): PriorityColor => {
    return PRIORITY_CONFIG[toPriority(priority)].color
  }

  const getPriorityDisplayName = (priority: any): string => {
    return PRIORITY_CONFIG[toPriority(priority)].display_name
  }

  return {
    PRIORITY_CONFIG,
    getPriorityColor,
    getPriorityDisplayName
  }
}
